<template>
    <div>
    <h2> Astral Realm:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg','Astral Realm')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/230378440/Hh0vqx8tCJJSt3q57MpjUQ/original.jpg?162456981055" target="_blank">Map</a><br/>
    The Astral Realm is a final encounter. It is arena style, so monsters will spawn one after another.
    <v-row>
        <v-col>
            <img id="Astral Realm" :src="require('../../../assets/Annotated_Astral_Realm_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in the Astral Plane, since this is only a memory of the astral plane its affects such as enhanced magic are not affecting players or creatures. However players and creatures cannot become incorporeal.</li>
            <li>The entire area and far into the distance is visible</li>
            <li>The ceiling in the center room is infinte, however any monster can spend a standard action to move the entire platform and all creatues on it any distance it likes. Players can know monsters have this ability with a dc 29 knowledge planes or arcana check.</li>
            <li>Once players have been on this encounter for 1 hour (real time) players receive 2d6 constitution drain from severe radiation damage, but they can make a fortitude save DC 19 to reduce the drain by half. Every 10 minutes after that they must make the save again, but the DC increases by 4 each time they have had to make it. Characters immune to poison take 1d6 points of constitution drain instead and gain +8 to their save.</li>
            <li>Map is 30x30</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Monsters: Red</li>
                <li>Areas of interest: Green</li>
            </ul>
        </ul>
        <br/><br/>     

        <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 17: </b> </li>
            First wave appears the moment players enter arena. 
            <ul>
                <li><b>1) Astradaemon CR 16: </b> Can use the teleportation runes as a free action</li>
                <li><b>2) 2x Astral Stalker CR 12: </b> Can use the teleportation runes as a free action</li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 18: </b> </li>
            Wave 2 begins 3 rounds after all monsters from wave 1 are slain. Players can hear what sounds like a roar in the distance but they can't see what it was. A knowledge nature DC 31 can tell it's an astral dragon's roar.
            <ul>
                <li><b>1) Ancient Astral Dragon CR 18: </b> Astral dragon viewed entire first combat and is therefor aware of all abilities party used in the first combat. Combat starts with the astral dragon attempting its possession power from a location the party cannot see on whichever target the dragon believes is the largest threat. If a player fails against its possession power they also lose 50% of their current spellpoints and the dragon gains 2 power points. Once it is out of power points it It then flys over them attempting to stay at a distance trying to use its ranged spells and breath weapon to kill players safely. Dragon enters having already cast haste, displacement, greater false life, and mirror image. If players successfully move the platform under it it lands and will attempt to fight them in melee. Dragons hit points become 720, it gains 4 mythic points, and it gains the following abilities:
                <ul>
                    <li><b>Mythic Status Resistance: </b> 1 point, when he is affected by any negative status he wants to ignore he can spend a mythic point to completely negate it, this is not an action and can be done whenever he so chooses. This can negate any negative status, even grappling (but not death)</li>
                    <li><b>Mythic Spellcasting: </b> For one mythic point the astral dragon can recast a spell it has already cast, or while casting a spell it can spend 1 mythic point to increase the DC by 1d4 (only once per spell).</li>
                </ul>
                </li>
            </ul>
            <br/>           
        </ul>
        <br/><br/>   
                
        </v-col>
    </v-row>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) E+ Stats 50</b></li>
            <li><b>2) Level Up 225</b></li>
            <li><b>3) 3 Spells/Maneuvers 100</b></li>
            <li><b>4) R+ Armor Enchantment 100</b></li>
            <li><b>5) R+ Stats 50</b></li>
            <li><b>6) Roll 2x Feat 175</b></li>
            <li><b>7) 3 Spells/Maneuvers 100 </b></li>
            <li><b>8) Typed Perk 125</b></li>
            <li><b>9) L+ Stats 50: </b></li>
            <li><b>10) 4-8 Typed Potions 50</b></li>
            <li><b>11) R+ Armor Enchantment 100</b></li>
            <li><b>12) R+ Weapon Enchantment 100</b></li>
            <li><b>13) R+ Armor Enchantment 100</b></li>
            <li><b>14) Typed Feat 125</b></li>
            <li><b>15) R+ Stats 50</b></li>
            <li><b>16) 4-8 Potions 50</b></li>
            <li><b>17) R+ Weapon Enchantment 100</b></li>
            <li><b>18) Fighter Perk 125</b></li>
            <li><b>19) Metamagic Feat 125</b></li>
            <li><b>20) R+ Perk 125</b></li>
            <li><b>21) L+ Weapon Enchantment 125</b></li>
            <li><b>22) Resurrective 75</b></li>
        </ul>
        <br/><br/>
        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Teleportation Runes: </b> A player standing on a square containing a teleportation rune can as a movement action attempt an DC 15 intelligence check or dc 33 spellcraft check to teleport to any other square also containing a teleportation rune. They can increase the DC of the intelligence check by 4 or the spellcraft check DC by 8 to teleport to any square they can see. Alternatively a player can attempt a DC 26 intelligence check or DC 43 spellcraft check to move the entire platform and any creature currently touching it to anywhere in the astral plane they can see. NOTE: THIS DOES REQUIRE AN INTELLIGENCE CHECK, NOT JUST THEIR HIGHEST MENTAL STAT</li>
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>